import { EMPTY_LIST } from '../../../../../constants/common'
import { toFlatSelectItem, toFlatSelectItems } from '../../../../Flat'
import {
  EMAIL_RECIPIENTS_BUILDING_FIELD_NAME,
  EMAIL_RECIPIENTS_BUILDING_GROUP_FIELD_NAME,
  EMAIL_RECIPIENTS_FLAT_FIELD_NAME,
  EMAIL_RECIPIENTS_PROPERTY_OWNER_ROLE,
  ROLE_OPTIONS,
} from '../EmailRecipientsFilterModal.constants'
import { getOptions } from '../EmailRecipientsFilterModal.utils'

function toFlatWithBuildingSelectItem(item) {
  return {
    ...toFlatSelectItem(item),
    additionalData: item.building.title,
    building: item.building,
  }
}

export function isEmailRecipientsPropertyOwnerRole(role) {
  return role?.value === EMAIL_RECIPIENTS_PROPERTY_OWNER_ROLE
}

export function hasEmailRecipientsBuildingScope({
  [EMAIL_RECIPIENTS_BUILDING_FIELD_NAME]: buildings = EMPTY_LIST,
  [EMAIL_RECIPIENTS_BUILDING_GROUP_FIELD_NAME]: buildingGroups = EMPTY_LIST,
}) {
  return buildings.length > 0 || buildingGroups.length > 0
}

export function toFlatWithBuildingSelectItems(items) {
  return toFlatSelectItems(items, toFlatWithBuildingSelectItem)
}

export function filterFlatOptions({
  [EMAIL_RECIPIENTS_BUILDING_FIELD_NAME]: buildings = EMPTY_LIST,
  [EMAIL_RECIPIENTS_FLAT_FIELD_NAME]: flats = EMPTY_LIST,
}) {
  const buildingIds = buildings.map(building => building.value)

  return flats.filter(flat => buildingIds.includes(flat.building.id))
}

export function getRoleOptions(values, t) {
  const withBuildingScope = hasEmailRecipientsBuildingScope(values)

  return getOptions(ROLE_OPTIONS, t).map(option =>
    !withBuildingScope && isEmailRecipientsPropertyOwnerRole(option)
      ? {
          ...option,
          disabled: true,
          tooltipContent: t('Email.SelectBuildingOrBuildingGroupTooltipKey'),
        }
      : option
  )
}
